require('sass/brands/locations.wendys.com/directory/default.scss');
require('js/locationList-script.js');
